import Component from 'D:/HBuilderProjects/园博园/uni_modules/uni-segmented-control/components/uni-segmented-control/uni-segmented-control.vue'
wx.createComponent(Component)